export default "__VITE_ASSET__gqUuTMgA__"